import { computed, ref, watch } from 'vue';
import { createStorage } from '@aviata/storage';

import type { FreedomCashbackModel } from '../../../features/freedom-cashback/model';

const APPLICABLE_KEY = 'freedom:cashback-promo-shown';
const ACTIVE_KEY = 'freedom:cashback-promo-active-shown';

const storage = createStorage(localStorage);

export const useCashbackPromoVisibility = (model: FreedomCashbackModel) => {
  const hasShownApplicable = ref(Boolean(storage.parse(APPLICABLE_KEY)));
  const hasShownActive = ref(Boolean(storage.parse(ACTIVE_KEY)));

  const shouldShow = computed(() => {
    if (model.isLoading.value || model.userBeforeFlag.value === 1) {
      return false;
    }
    if (model.isPromoActive.value) {
      return !hasShownActive.value;
    }
    if (model.isUserApplicableForPromo.value) {
      return !hasShownApplicable.value;
    }

    return false;
  });

  const markAsShown = () => {
    if (model.isPromoActive.value) {
      hasShownActive.value = true;
      storage.set(ACTIVE_KEY, 'true');
    } else if (model.isUserApplicableForPromo.value) {
      hasShownApplicable.value = true;
      storage.set(APPLICABLE_KEY, 'true');
    }
  };

  watch(
    model.userBeforeFlag,
    flag => {
      if (flag === 1) {
        hasShownApplicable.value = false;
        hasShownActive.value = false;
        localStorage.removeItem(APPLICABLE_KEY);
        localStorage.removeItem(ACTIVE_KEY);
      }
    },
    { immediate: true },
  );

  return {
    shouldShow,
    markAsShown,
  };
};
